import { ErrorSnackContent } from '../types';
import { ErrorKeys, MessageKeys } from '../validators';
import i18next from 'i18next';

export const buildSnackConfig = (): Map<string | undefined, ErrorSnackContent> => {
  return new Map<string | undefined, ErrorSnackContent>([
    [
      ErrorKeys.FIELDS_MISSING,
      {
        title: 'Поля не заполнены',
        message: i18next.t(MessageKeys.FILL_REQUIRED_FIELDS),
        hideAfter: 3000,
      },
    ],
    [
      ErrorKeys.WRONG_EMAIL,
      {
        title: 'Ваша почта не прошла проверку',
        message: i18next.t(MessageKeys.CHECK_YOUR_EMAIL),
        hasButton: true,
      },
    ],
    [
      ErrorKeys.FAILED_TO_POST_ERROR,
      {
        title: 'Отзыв не отправлен',
        message: i18next.t(MessageKeys.FAILED_TO_POST),
        hasButton: true,
      },
    ],
    [
      ErrorKeys.MAX_LENGTH_EXCEEDED,
      {
        title: 'Не удалось опубликовать',
        message: i18next.t(MessageKeys.REDUCE_REVIEW_LENGTH),
        hasButton: true,
      },
    ],
  ]);
};
